import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { StorageDtoKeyEnum } from '@zaoblako/shared/modules/storage/enums/storage-dto-key.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';

import * as yup from 'yup';

/** S3 storaget credentials create and update APIs request body - DTO signature */
export interface StorageFormInterface {
  /** Display name */
  name: string;
  /** If `true` then `https:` connection will be used instead of `http:` */
  secured?: boolean;
  /** Region system name */
  region: string;
  /** Endpoint address */
  endpoint: string;
  /** Storage S3 access key */
  accessKey: string;
  /** Storage S3 secret key */
  secretKey: string;
}

/** S3 storaget credentials create and update APIs request body - DTO schema */
export const StorageFormDto = SerdeDtoClass.create<StorageFormInterface>(StorageDtoKeyEnum.STORAGE_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
  secured: {
    optional: true,
    label: 'Использовать защищенное соединение',
    serializer: yup.boolean(),
  },
  region: {
    optional: true,
    label: 'Регион',
    serializer: nonEmptyStringSchema,
  },
  endpoint: {
    label: 'Адрес',
    serializer: nonEmptyStringSchema,
  },
  accessKey: {
    label: 'Ключ доступа',
    serializer: nonEmptyStringSchema,
  },
  secretKey: {
    label: 'Секретный ключ',
    serializer: nonEmptyStringSchema,
  },
});
